import Fitting from '@/models/Fitting';
import FittingSession from '@/models/FittingSession';
import Order from '@/models/Order';

export default class SetFittingValuesByPreviousOrder
{
    /**
     * Vue Object
     */
    v = null;

    /**
     * "right" or "left"
     * @string
     */
    side = null;

    constructor(v, side)
    {
        this.v = v;
        this.side = side;
    }

    async handle()
    {
        /** @type {?Order} */
        const previousOrder = this.v.sides[this.side].previousOrder;
        if(!previousOrder)
        {
            return true;
        }

        /** @type {Fitting} */
        const fitting = this.v.$store.getters['lensOrder/getFitting'](this.side);

        if(!this.v.isOrderEdition)
        {
            // This is a reorder.

            // Set previous reference
            fitting.reference = null;
            fitting.previous_order_reference = previousOrder.reference;
            console.log(`Fitting previous reference was set to ${previousOrder.reference}`);
            return true;
        }

        // This is an order edition.

        // Set reference
        fitting.reference = previousOrder.reference;
        fitting.previous_order_reference = previousOrder.previous_order_reference;
        fitting.currency_code = previousOrder.currency_code;
        fitting.special_price = previousOrder.special_price;

        // Set fitting session ID
        if(previousOrder.fitting_session_id)
        {
            fitting.session_id = previousOrder.fitting_session_id;
        }

        // Sum order price and all order supplements price.
        let fullPrice = previousOrder.price;
        for(const supplement of previousOrder.supplements)
        {
            fullPrice += supplement.price;
        }

        fitting.customer_price = fullPrice;

        console.log(`Fitting reference was set to ${previousOrder.reference}`);

        return true;
    }
}
